import { createBlock as c, openBlock as r, resolveDynamicComponent as f, normalizeClass as p, withCtx as u, createElementVNode as g, renderSlot as l } from "vue";
import { themeProp as $ } from "../../../composables/useTheme.js";
import { sectionProps as S } from "../mixins/useSectionProps.js";
/* empty css                    */
const C = {
  __name: "section-single",
  props: {
    ...S,
    ...$,
    /**
     * @TODO: Add a more generic case to accept other tags like `article` etc.
     * Renders a `div` or a `section` html tag
     * Be aware of corner cases like passing `null` that will override the `default` value and render a `div`
     */
    isSectionTag: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  setup(a) {
    const e = a, i = (t) => {
      const n = t === "bottom", d = t === "top", m = e.spaceOptionsSmall, s = e.spaceOptionsMedium;
      let o = "";
      return e.withSpace && (n && e.withSpaceBottom && (m.bottom && (o += `ds-padding-${t}-48`, s.bottom || (o += ` ds-md-padding-${t}-0`)), s.bottom && (o += ` ds-md-padding-${t}-96`)), d && e.withSpaceTop && (m.top && (o += ` ds-padding-${t}-48`, s.top || (o += ` ds-md-padding-${t}-0`)), s.top && (o += ` ds-md-padding-${t}-96`))), o;
    };
    return (t, n) => (r(), c(f(a.isSectionTag ? "section" : "div"), {
      class: p(["ds-section", [`ds-section--${t.theme}`, i("top"), i("bottom")]])
    }, {
      default: u(() => [
        g("div", {
          class: p({ "ds-container": !t.fullScreen })
        }, [
          l(t.$slots, "default")
        ], 2),
        l(t.$slots, "full-screen")
      ]),
      _: 3
    }, 8, ["class"]));
  }
};
export {
  C as default
};
